import { api } from 'index'

const createLoader =
  (base) =>
  async ({ params, request }) => {
    const url = new URL(request.url)
    let _base = base
    let _searchParams = {}

    if (!_base) {
      _base = url.pathname.split('/').filter((x) => x)[0] || 'review'
    }

    if (url.searchParams.size) {
      for (const [key, value] of url.searchParams.entries()) {
        if (_searchParams[key]) {
          _searchParams[key] = [
            ...(Array.isArray(_searchParams[key])
              ? _searchParams[key]
              : [_searchParams[key]]),
            value,
          ]
          continue
        }

        _searchParams[key] = value
      }
    }

    let data

    try {
      data = await api[_base].get({
        path: url.pathname,
        params: {
          ...params,
          ..._searchParams,
        },
      })
    } catch (e) {
      console.error(e)
    }

    return data
  }

export default createLoader
